// extracted by mini-css-extract-plugin
module.exports = {"latest":"posts-module--latest--30ZP5","meta":"posts-module--meta--2W1R1","readmore":"posts-module--readmore--MN_rw"};